import { PortalOperator } from "./portal-operator";
import { Fine, Payment } from ".";
import { Card } from "./card";

export class Client extends PortalOperator {
    Cards?: Array<Card>
    Fines?: Array<Fine>;
    Payments?: Array<Payment>;
    Vehicles?: Array<any>;

    // Model properties
    FinesNo?: number;
    PaymentsNo?: number;
    PortalOperatorCards?: any;
}